import { render } from "./UploadVolume.vue?vue&type=template&id=b89f3e0a&scoped=true"
import script from "./UploadVolume.vue?vue&type=script&lang=js"
export * from "./UploadVolume.vue?vue&type=script&lang=js"

import "./UploadVolume.vue?vue&type=style&index=0&id=b89f3e0a&scoped=true&lang=less"

import exportComponent from "/builds/cloudstack/keycloak-auth/.cloudstack-src/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89f3e0a"]])

export default __exports__